import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { TransformerManagerService } from 'src/app/services/transformerManager.service';
import { MaintainanceComponent } from '../maintainance/maintainance.component';

@Component({
  selector: 'app-addresolution',
  templateUrl: './addresolution.component.html',
  styleUrls: ['./addresolution.component.scss']
})
export class AddresolutionComponent implements OnInit {
  formGroup: FormGroup;
  siteName:any = [];
  transformerid;
  selectedSite;
  action = "add";
  sitemanagers;
  loginUserData= JSON.parse(localStorage.getItem("userData"));
  selectedMaintainance: any = [];

  constructor(private fb: FormBuilder,private transMngSer:TransformerManagerService,private tostr:ToastrService,private dialogRef: MatDialogRef<MaintainanceComponent>,@Inject(MAT_DIALOG_DATA) public formdata: { data:any}) { }

 async ngOnInit() {
    this.formGroup = this.fb.group({
      sitename:  new FormControl(null, [Validators.required]),
      transformerid:  new FormControl(''),
      maintainance: new FormControl(null, [Validators.required]),
      date: new FormControl(null, [Validators.required]),
      resolutionmethod: new FormControl(null, [Validators.required]),
      engineername: new FormControl(null, [Validators.required]),
      partreplaced: new FormControl(null, [Validators.required]),
      rootcause:new FormControl(null, [Validators.required]),
      transformerstatus: new FormControl(null, [Validators.required]),
      notes:  new FormControl(null),
    });
    this.siteName = await this.getDdlData();
    this.sitemanagers = this.siteName.map(site => site.sitemanager);
    if(typeof this.formdata == 'object' && !Array.isArray(this.formdata)){
      console.log("form data",this.formdata)
      this.action = "edit";
      this.patchFormData(this.formdata);
    }
  }

  getTransformerID(sitename){
    this.selectedSite = sitename.serialnumber;
    this.formGroup.controls['transformerid'].setValue(sitename.serialnumber);
    this.getData()
  }
  getDdlData() {
    return new Promise((resolve, reject) => {
        this.transMngSer.getTransformerData(JSON.parse(localStorage.getItem('userData')).roleid, JSON.parse(localStorage.getItem('userData')).userid, 'x``z').toPromise().then((response: any) => {
             if(response.data.length > 0)
             {
                resolve(response.data);
             }
            resolve([]);
        });
    })
}
getData(){
  this.transMngSer.getMaintenancePlanningData({"userid":this.loginUserData.userid,"transformerid":this.selectedSite}).toPromise().then((response: any) => {
    if(response.code == 1)
    {
      console.log("data",response.data)
      this.selectedMaintainance = response.data
    }
  });
}

submit(formdata){
  let maintenanceData = formdata.value;
maintenanceData.login_user_id = this.loginUserData.userid;
let msg = "Plan Created";
if(this.action == "edit"){
  maintenanceData.id = this.formdata['id'];
  msg  = "Plan Updated"
}
  let resolutionData = formdata.value;
  let matchingObject = this.selectedMaintainance.find((item) => item.selectedOptions == resolutionData.maintainance);
  let id = matchingObject ? matchingObject.id : null;
  resolutionData.maintainancePlanningID = id;
  resolutionData.loginuserid = this.loginUserData.userid;
  this.transMngSer.addResolution(resolutionData).toPromise().then((response: any) => {
    if(response.code ==1)
    {
      this.tostr.success("created")
      this.dialogRef.close();
    }
  });

console.log(resolutionData);
}
patchFormData(valuesObject){
  this.selectedMaintainance =[{"selectedOptions":valuesObject.maintainance}];
  this.formGroup.patchValue({
    sitename:  valuesObject.sitename,
      transformerid:  valuesObject.transformerid,
      maintainance:  valuesObject.maintainance,
      date: new Date(valuesObject.currentdatetime),
      resolutionmethod: valuesObject.resolutionmethod,
      engineername: valuesObject.engineername,
      partreplaced: valuesObject.partreplaced,
      rootcause: valuesObject.rootcause,
      transformerstatus: valuesObject.transformerstatus,
      notes:  valuesObject.comments,
  })
  Object.keys(this.formGroup.controls).forEach((field) => {
    const control = this.formGroup.get(field);
    if (control) {
      control.disable();
    }
  });
}
editData(){
  Object.keys(this.formGroup.controls).forEach((field) => {
    const control = this.formGroup.get(field);
      if (control) {
        control.enable();
      }
  });
}


}
